import Box from '@mui/material/Box'
import withWidth, { isWidthUp } from '@mui/material/Hidden/withWidth'
import Tooltip from '@mui/material/Tooltip'
import React from 'react'
import questionMark from 'src/assets/images/common/questionMark.svg'
import questionMarkBlue from 'src/assets/images/common/questionMarkBlue.svg'
import { openModalFn } from 'src/utils/controllers/ModalController'
import { checkMobileDevice } from 'src/utils/utils/commonUtils'

function TooltipButton({
  content,
  width,
  iconColor,
  title,
  titleIcon,
  placement,
  buttonIcon,
  minWidth,
  href,
}) {
  const openModal = () => {
    if (!isWidthUp('sm', width) || checkMobileDevice()) {
      openModalFn['custom-tooltip']({ content, title, iconColor: titleIcon })
    }
  }

  return content || href ? (
    <>
      <Tooltip
        title={content ?? ''}
        disableTouchListener={true}
        disableHoverListener={!isWidthUp('sm', width) || !content}
        placement={placement}
        slotProps={{ tooltip: { sx: { minWidth } } }}
      >
        <Box
          sx={{
            width: '25px',
            height: '25px',
            background: iconColor === 'blue' ? undefined : '#E0DFDF',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            '&:hover': {
              background: iconColor === 'blue' ? undefined : '#c5c5c5',
              cursor: 'pointer',
            },
          }}
          onClick={openModal}
          href={href}
          target='_blank'
          component={href ? 'a' : 'div'}
        >
          <img
            draggable='false'
            src={
              buttonIcon
                ? buttonIcon
                : iconColor === 'blue'
                  ? questionMarkBlue
                  : questionMark
            }
            alt=''
          />
        </Box>
      </Tooltip>
    </>
  ) : null
}

export default withWidth()(TooltipButton)
